document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".clinical-slides-track");
  const slides = document.querySelectorAll(".clinical-slide");
  const leftArrow = document.querySelector(".clinical-arrow.clinical-left");
  const rightArrow = document.querySelector(".clinical-arrow.clinical-right");
  const dotsContainer = document.querySelector(".clinical-pagination-dots");

  if (!track || slides.length === 0 || !leftArrow || !rightArrow || !dotsContainer) {
    return;
  }

  let currentIndex = 0;
  let touchStartX = 0;
  let touchEndX = 0;

  function getSlidesPerView() {
    return window.innerWidth <= 768 ? 1 : 3;
  }

  function getTotalPages() {
    return Math.ceil(slides.length / getSlidesPerView());
  }

  function updateTrackPosition() {
    const slideWidth = slides[0].offsetWidth + 10;
    const offset = currentIndex * slideWidth * getSlidesPerView();
    track.style.transform = `translateX(-${offset}px)`;
    updateDots();
  }

  function updateDots() {
    const totalPages = getTotalPages();
    dotsContainer.innerHTML = "";
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement("div");
      dot.classList.add("clinical-dot");
      if (i === currentIndex) dot.classList.add("clinical-active");
      dot.addEventListener("click", () => {
        currentIndex = i;
        updateTrackPosition();
      });
      dotsContainer.appendChild(dot);
    }
  }

  leftArrow.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + getTotalPages()) % getTotalPages();
    updateTrackPosition();
  });

  rightArrow.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % getTotalPages();
    updateTrackPosition();
  });

  window.addEventListener("resize", () => {
    currentIndex = 0;
    updateTrackPosition();
  });

  track.addEventListener("touchstart", function (e) {
    touchStartX = e.changedTouches[0].screenX;
  });

  track.addEventListener("touchend", function (e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeThreshold = 50;

    if (touchEndX < touchStartX - swipeThreshold) {
      currentIndex = (currentIndex + 1) % getTotalPages();
      updateTrackPosition();
    } else if (touchEndX > touchStartX + swipeThreshold) {
      currentIndex = (currentIndex - 1 + getTotalPages()) % getTotalPages();
      updateTrackPosition();
    }
  }

  updateTrackPosition();
});